import { FC } from "react";
import { IAllIpoListCmpData } from "../../interfaces/IpoList.interface";
import { MAINBOARD, SME } from "./IpoListConstants";
import { getIpoListData } from "../../services/TradingMallService";
import IpoListWrapper from "./IpoListWrapper"; 
import IpoTitle from "../IpoTitleWithDescription/IpoTitle";
import { twMerge } from "tailwind-merge";

const IpoList: FC<IAllIpoListCmpData> = async (props) => {
  const parsedPaginationLimit = Number.parseInt(props.paginationLimit ?? "3");
  const normalizedIpoType = props?.ipoType?.toLowerCase() ?? "";
  const [mainboardRes, smeRes] = await Promise.all([
    getIpoListData({
      ipoType: normalizedIpoType,
      limit: parsedPaginationLimit,
      page: 1,
      subType: MAINBOARD,
    }),
    getIpoListData({
      ipoType: normalizedIpoType,
      limit: parsedPaginationLimit,
      page: 1,
      subType: SME,
    }),
  ]);

  return (
    <section className={twMerge(`flex flex-col gap-[16px] ${props.componentLink}`, props.customClass ?? "")} id={props.componentLink}>

      <IpoTitle
        ipoTitle={props.ipoTitle}
        ipoDescription={props.signInText}
        ipoType={props.ipoType}
        defaultVariant={false}
        mainboardCount={mainboardRes?.data?.totalcount}
        smeCount={smeRes?.data?.totalcount}
        headingLevel={props.headingLevel}
      />

      <IpoListWrapper
        {...props}
        mainboardInitial={mainboardRes}
        smeInitial={smeRes}
      />
    </section>
  );
};

export default IpoList;
